import createClient from '@economic/http-client';
import { AxiosInstance } from 'axios';
import { INTERNAL_API_APP_TOKEN_URL } from './internalApiClient';

export { createJsonPatchOperation } from '@economic/http-client';

let api: AxiosInstance;

export function setupInAppHelpApiClient(url: string): void {
    api = createClient(`${url}/api`, {
        url: INTERNAL_API_APP_TOKEN_URL,
        headerKey: 'Authorization',
        tokenName: 'Bearer ',
        tokenTimeout: 60,
    });
}

export default function getInAppHelpApiClient() {
    if (!api) {
        throw new Error('Call setupInAppHelpApiClient before using open API');
    }

    return api;
}
